import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Divider, IconButton } from '@mui/material';
import React from 'react';
export const CardAction = (props) => {
    return (React.createElement(Box, { sx: {
            alignSelf: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 'auto',
        }, "data-test": 'action' },
        React.createElement(Divider, { orientation: 'vertical', flexItem: true, variant: 'middle' }),
        React.createElement(Box, { sx: {
                px: 1,
            } },
            React.createElement(IconButton, { color: 'primary', "aria-label": props.ariaLabel, onClick: props.onClick }, props.icon ? props.icon : React.createElement(AddCircleOutlineIcon, null)))));
};
